/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
import axios from 'axios';
export class ContentfulApiClient {
    constructor(baseUrl, instance) {
        Object.defineProperty(this, "instance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "baseUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "jsonParseReviver", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: undefined
        });
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    getEntry(contentTypeId, codeId, include, usePreviewApi, cancelToken) {
        let url_ = this.baseUrl + "/contentful/v2/GetEntry?";
        if (contentTypeId === null)
            throw new Error("The parameter 'contentTypeId' cannot be null.");
        else if (contentTypeId !== undefined)
            url_ += "contentTypeId=" + encodeURIComponent("" + contentTypeId) + "&";
        if (codeId === null)
            throw new Error("The parameter 'codeId' cannot be null.");
        else if (codeId !== undefined)
            url_ += "codeId=" + encodeURIComponent("" + codeId) + "&";
        if (include === null)
            throw new Error("The parameter 'include' cannot be null.");
        else if (include !== undefined)
            url_ += "include=" + encodeURIComponent("" + include) + "&";
        if (usePreviewApi === null)
            throw new Error("The parameter 'usePreviewApi' cannot be null.");
        else if (usePreviewApi !== undefined)
            url_ += "usePreviewApi=" + encodeURIComponent("" + usePreviewApi) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };
        return this.instance.request(options_).catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then((_response) => {
            return this.processGetEntry(_response);
        });
    }
    processGetEntry(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status === 400) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        }
        else if (status === 404) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        Object.defineProperty(this, "message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "result", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isApiException", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
//# sourceMappingURL=contentful.api.client.js.map